<template>
  <form @submit.prevent="submit(item)">
    <b-row v-if="page === 1">
      <b-col md="8" v-if="itemTagOptions.length > 0">
        <b-form-group>
          <label>{{$t("views.exsbitems.form.tags")}}: </label>
          <multi-select :options="itemTagOptions" :selected-options="item.itemTags" @select="onSelectTags" >
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col md="8" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_name"
            class="form-control-label">{{$t('views.exsbitems.form.name')}}:</label>
          <input
            id="exsbitem_name"
            v-model="item.name"
            :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            @input="handleUpdateField('name', $event.target.value)">
          <div
            v-if="isInvalid('name')"
            class="invalid-feedback">{{ violations.name }}</div>
        </div>
      </b-col>
      <b-col md="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_itemType"
            class="form-control-label">{{$t('views.exsbitems.form.itemType')}}:</label>
          <fg-input :error="violations.itemType">
            <el-select
              id="exsbitem_itemType"
              :class="['select-default', isInvalid('itemType') ? 'select-danger' : '']"
              :placeholder="$t('views.exsbitems.form.itemType')"
              filterable
              v-model="item.itemType">
              <el-option v-for="option in itemTypes"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('itemType')"
            class="invalid-feedback">{{ violations.itemType }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_category"
            class="form-control-label">{{$t('views.exsbitems.form.category')}}:</label>
          <fg-input :error="violations.itemType">
            <el-select
              id="exsbitem_category"
              :class="['select-default', isInvalid('category') ? 'select-danger' : '']"
              :placeholder="$t('views.exsbitems.form.category')"
              filterable
              v-model="item.category">
              <el-option v-for="option in categories"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('category')"
            class="invalid-feedback">{{ violations.category }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_measure"
            class="form-control-label">{{$t('views.exsbitems.form.measure')}}:</label>
          <fg-input :error="violations.measure">
            <el-select
              id="exsbitem_measure"
              :class="['select-default', isInvalid('measure') ? 'select-danger' : '']"
              :placeholder="$t('views.exsbitems.form.measure')"
              filterable
              v-model="item.measure">
              <el-option v-for="option in measures"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.name"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('measure')"
            class="invalid-feedback">{{ violations.measure }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_brand"
            class="form-control-label">{{$t('views.exsbitems.form.brand')}}:</label>
          <fg-input :error="violations.itemType">
            <el-select
              id="exsbitem_brand"
              :class="['select-default', isInvalid('brand') ? 'select-danger' : '']"
              :placeholder="$t('views.exsbitems.form.brand')"
              filterable
              v-model="item.brand">
              <el-option v-for="option in itemBrands"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.brandTitle"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('brand')"
            class="invalid-feedback">{{ violations.brand }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_vatRate"
            class="form-control-label">{{$t('views.exsbitems.form.vatRate')}}:</label>
          <fg-input :error="violations.vatRate">
            <el-select
              id="exsbitem_vatRate"
              :class="['select-default', isInvalid('vatRate') ? 'select-danger' : '']"
              :placeholder="$t('views.exsbitems.form.vatRate')"
              filterable
              @input="vatRateSelected($event)"
              v-model="item.vatRate">
              <el-option v-for="option in vatRates"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.range"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
            v-if="isInvalid('vatRate')"
            class="invalid-feedback">{{ violations.vatRate }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_priceNetto"
            class="form-control-label">{{$t('views.exsbitems.form.priceNetto')}}:</label>
          <input
            id="exsbitem_priceNetto"
            v-model="item.priceNetto"
            :class="['form-control', isInvalid('priceNetto') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            :disabled="isPriceNettoDisabled"
            @input="handleUpdateField('priceNetto', $event.target.value); priceNettoSelected()">
          <div
            v-if="isInvalid('priceNetto')"
            class="invalid-feedback">{{ violations.priceNetto }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_priceBrutto"
            class="form-control-label">{{$t('views.exsbitems.form.priceBrutto')}}:</label>
          <input
            id="exsbitem_priceBrutto"
            v-model="item.priceBrutto"
            :class="['form-control', isInvalid('priceBrutto') ? 'is-invalid' : '']"
            type="text"
            required="true"
            placeholder=""
            :disabled="isPriceBruttoDisabled"
            @input="handleUpdateField('priceBrutto', $event.target.value); priceBruttoSelected()">
          <div
            v-if="isInvalid('priceBrutto')"
            class="invalid-feedback">{{ violations.priceBrutto }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="12">
        <div class="form-group">
          <label
            for="exsbitem_priceGroup"
            class="form-control-label">{{$t('views.exsbitems.form.priceGroup')}}:</label>
          <model-select :options="priceGroups" v-model="item.priceGroup"></model-select>
          <div
            v-if="isInvalid('priceGroup')"
            class="invalid-feedback">{{ violations.priceGroup }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="page === 2">
      <b-col lg="4" sm="6">
        <div class="form-group">
          <label
            for="exsbitem_receiptName"
            class="form-control-label">{{$t('views.exsbitems.form.receiptName')}}:</label>
          <input
            id="exsbitem_receiptName"
            v-model="item.receiptName"
            :class="['form-control', isInvalid('receiptName') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('receiptName', $event.target.value)">
          <div
            v-if="isInvalid('receiptName')"
            class="invalid-feedback">{{ violations.receiptName }}</div>
        </div>
      </b-col>
      <b-col lg="4" sm="6">
        <div class="form-group">
          <label
            for="exsbitem_catalogNumber"
            class="form-control-label">{{$t('views.exsbitems.form.catalogNumber')}}:</label>
          <input
            id="exsbitem_catalogNumber"
            v-model="item.catalogNumber"
            :class="['form-control', isInvalid('catalogNumber') ? 'is-invalid' : '']"
            type="text"
            placeholder=""
            @input="handleUpdateField('catalogNumber', $event.target.value)">
          <div
            v-if="isInvalid('catalogNumber')"
            class="invalid-feedback">{{ violations.catalogNumber }}</div>
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="purchase_price_netto"
                 class="form-control-label">{{$t('views.exsbitems.form.purchasePriceNetto')}}</label>
          <input
            id="purchase_price_netto"
            type="text"
            v-model="item.purchasePriceNetto"
            class="form-control"
            @input="handleUpdateField('purchasePriceNetto', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="warining_availability"
                 class="form-control-label">{{$t('views.exsbitems.form.height')}}</label>
          <input
            id="height"
            type="number"
            v-model.number="item.height"
            class="form-control"
            @input="handleUpdateField('height', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="width"
                 class="form-control-label">{{$t('views.exsbitems.form.width')}}</label>
          <input
            id="width"
            type="number"
            v-model.number="item.width"
            class="form-control"
            @input="handleUpdateField('width', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="weight"
                 class="form-control-label">{{$t('views.exsbitems.form.weight')}}</label>
          <input
            id="weight"
            type="number"
            v-model.number="item.weight"
            class="form-control"
            @input="handleUpdateField('weight', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="color"
                 class="form-control-label">{{$t('views.exsbitems.form.color')}}</label>
          <input
            id="color"
            type="text"
            v-model="item.color"
            class="form-control"
            @input="handleUpdateField('color', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="customSymbol"
                 class="form-control-label">{{$t('views.exsbitems.form.customSymbol')}}</label>
          <input
            id="customSymbol"
            type="text"
            v-model="item.customSymbol"
            class="form-control"
            @input="handleUpdateField('customSymbol', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" lg="4">
        <div class="form-group">
          <label for="advantage"
                 class="form-control-label">{{$t('views.exsbitems.form.advantage')}}</label>
          <input
            id="advantage"
            type="text"
            v-model="item.advantage"
            class="form-control"
            @input="handleUpdateField('advantage', $event.target.value)">
        </div>
      </b-col>
      <template v-if="getIdLink(item.itemType) === '1'">
        <b-col sm="12" md="3">
          <div class="form-group">
            <label for="warining_availability"
                   class="form-control-label">{{$t('views.exsbitems.form.warningAvailability')}}</label>
            <input
              id="warining_availability"
              type="text"
              v-model.number="item.warningAvailability"
              class="form-control"
              @input="handleUpdateField('warningAvailability', $event.target.value)">
          </div>
        </b-col>
        <b-col sm="12" md="3">
          <div class="form-group">
            <label for="minimum_availability"
                   class="form-control-label">{{$t('views.exsbitems.form.minimumAvailability')}}</label>
            <input
              id="minimum_availability"
              type="text"
              v-model.number="item.minimumAvailability"
              class="form-control"
              @input="handleUpdateField('minimumAvailability', $event.target.value)">
          </div>
        </b-col>
      </template>
      <b-col v-if="getIdLink(item.itemType) === '2'" sm="12" md="3">
        <label for="cyclic_input">{{$t('views.exsbitems.form.isCyclic')}}:</label>
        <b-form-group>
          <b-form-radio-group
            id="cyclic_input"
            buttons
            button-variant="outline-primary"
            v-model="item.isCyclic"
          >
            <b-form-radio :value="0">{{$t("buttons.no")}}</b-form-radio>
            <b-form-radio class="btn-success" :value="1">{{$t("buttons.yes")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <label for="cyclic_input">{{$t('views.exsbitems.form.joinWithPreviousItemFromPriceGroup')}}:</label>
        <b-form-group>
          <b-form-radio-group
            id="cyclic_input"
            buttons
            button-variant="outline-primary"
            v-model="item.joinWithPreviousItemFromPriceGroup"
          >
            <b-form-radio :value="0">{{$t("buttons.no")}}</b-form-radio>
            <b-form-radio class="btn-success" :value="1">{{$t("buttons.yes")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <label for="cyclic_input">{{$t('views.exsbitems.form.treatQuantityAsSingleFromPriceGroup')}}:</label>
        <b-form-group>
          <b-form-radio-group
            id="cyclic_input"
            buttons
            button-variant="outline-primary"
            v-model="item.treatQuantityAsSingleFromPriceGroup"
          >
            <b-form-radio :value="0">{{$t("buttons.no")}}</b-form-radio>
            <b-form-radio class="btn-success" :value="1">{{$t("buttons.yes")}}</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <div class="form-group">
          <label for="range_from"
                 class="form-control-label">{{$t('views.exsbitems.form.rangeFrom')}}</label>
          <input
            id="range_from"
            type="text"
            v-model.number="item.rangeFrom"
            class="form-control"
            @input="handleUpdateField('rangeFrom', $event.target.value)">
        </div>
      </b-col>
      <b-col sm="12" md="4">
        <div class="form-group">
          <label for="range_to"
                 class="form-control-label">{{$t('views.exsbitems.form.rangeTo')}}</label>
          <input
            id="range_to"
            type="text"
            v-model.number="item.rangeTo"
            class="form-control"
            @input="handleUpdateField('rangeTo', $event.target.value)">
        </div>
      </b-col>
      <b-col cols="12">
        <hr class="mb-1 mt-1">
        <span class="h6">
          {{ $t('menu.exsbpriceuserdata.list') }}:
        </span>
      </b-col>
      <b-col cols="12" v-if="ableToAddPriceUserData">
        <b-row v-for="(item, index) in item.customPrices" :key="index" align-h="center">
          <b-col sm="12" md="1" class="text-center" align-self="center">
            <span class="h6">#{{ index + 1 }}</span>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-group>
              <label for="userdata_input">{{ $t('views.exsbpaymentsmade.list.contractor') }}</label>
              <model-select
                :isDisabled="isUpdate"
                id="userdata_input"
                :options="userDataOptions"
                v-model="item.idUserData"></model-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-group>
              <label for="promotion_input">{{ $t('views.exsbpaymentsmade.list.promotion') }}</label>
              <model-select
                :isDisabled="isUpdate"
                id="promotion_input"
                :options="promotionOptions"
                v-model="item.idPromotion"></model-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-group>
              <label for="price_brutto">{{ $t('views.exsbitems.form.priceBrutto') }}:</label>
              <input :disabled="isUpdate || isPriceBruttoDisabled"
                     :placeholder="$t('views.exsbitems.form.priceBrutto')"
                     v-model="item.priceBrutto"
                     type="text" class="form-control" id="price_brutto"
                     @input="customPriceBruttoSelected(index)">
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-group>
              <label for="price_brutto">{{ $t('views.exsbitems.form.priceNetto') }}:</label>
              <input
                :disabled="isUpdate || isPriceNettoDisabled"
                :placeholder="$t('views.exsbitems.form.priceNetto')"
                v-model="item.priceNetto"
                type="text" class="form-control" id="price_netto"
                required
                @input="customPriceNettoSelected(index)">
              <div v-if="isInvalid('priceNetto')" class="text-danger">
                {{ violations.priceNetto }}
              </div>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="1" align-self="center" v-if="!isUpdate">
            <button
              type="button"
              class="btn btn-link mt-1 fa fa-trash-alt fa-lg"
              @click="removePriceUserData(index)">
            </button>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <button
              type="button"
              class="btn btn-sm"
              @click="addPriceUserData()">
              <i class="mr-1 fa fa-plus"></i>
              {{$t('views.exsbpriceuserdata.form.addPriceUserData')}}
            </button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import { checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  components: {
    ModelSelect,
    MultiSelect
  },

  props: {
    page: Number,

    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
  },

  computed: {
    isUpdate () {
      return this.$route.name === 'EXSBItemUpdate'
    },
    userDataOptions () {
      return this.userDataRawOptions.map(entry => {
        return {
          value: getId(entry.value),
          text: entry.text
        }
      })
    },
    promotionOptions () {
      return this.promotionRawOptions.map(entry => {
        return {
          value: getId(entry.value),
          text: entry.text
        }
      })
    },
    ableToAddPriceUserData () {
      return checkPermission('warehouses', 'EXSBPriceUserDataCreate')
    },
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    },
    ...mapGetters({
      itemTypes: 'lists/list/itemTypesItems',
      itemBrands: 'lists/list/itemBrandsItems',
      categories: 'lists/list/itemCategoriesItems',
      priceGroups: 'lists/list/priceGroupsItems',
      measures: 'lists/list/measuresItems',
      vatRates: 'lists/list/vatRatesItems',
      itemOptions: 'exsbpriceuserdata/list/itemOptions',
      userDataRawOptions: 'exsbpriceuserdata/list/userDataOptions',
      promotionRawOptions: 'exsbpriceuserdata/list/promotionOptions',
      getPromotions: 'agreements/list/getPromotions'
    }),
    vatRate () {
      if (!this.item.vatRate) return 0
      else {
        return this.vatRates.find(entry => {
          return entry['@id'] === this.item.vatRate
        }).value
      }
    }
  },

  created () {
    this.resetLists()
    this.getItemTypes()
    this.getItemBrands()
    this.getMeasures()
    this.getCategories()
    this.getPriceGroups()
    this.getVatRates()
    this.fetchItemOptions()
    this.fetchUserDataOptions()
    this.fetchItemTagOptions()
    this.fetchPromotionOptions()
  },

  destroyed () {
    this.resetLists()
  },

  data () {
    return {
      isPriceBruttoDisabled: true,
      isPriceNettoDisabled: false,
      itemTagOptions: []
    }
  },

  methods: {
    ...mapActions({
      getVatRates: 'lists/list/getVatRates',
      getItemTypes: 'lists/list/getItemTypes',
      getItemBrands: 'lists/list/getItemBrands',
      getCategories: 'lists/list/getItemCategories',
      getPriceGroups: 'lists/list/getPriceGroups',
      getMeasures: 'lists/list/getMeasures',
      resetLists: 'lists/list/reset',
      fetchItemOptions: 'exsbpriceuserdata/list/fetchItemOptions',
      fetchUserDataOptions: 'exsbpriceuserdata/list/fetchUserDataOptions',
      fetchPromotionOptions: 'exsbpriceuserdata/list/fetchPromotions'
    }),
    vatRateSelected () {
      this.priceNettoSelected()
      this.item.customPrices.forEach((entry, index) => {
        this.customPriceNettoSelected(index)
      })
    },
    clearAllPrices () {
      this.item.priceNetto = ''
      this.item.priceBrutto = ''
      this.item.customPrices.forEach(entry => {
        entry.priceBrutto = ''
        entry.priceNetto = ''
      })
    },
    priceNettoSelected () {
      let priceNetto = this.item.priceNetto
      if (!priceNetto) this.item.priceNetto = ''
      else this.item.priceBrutto = this.calculatePriceBrutto(priceNetto)
    },
    priceBruttoSelected () {
      let priceBrutto = this.item.priceBrutto
      if (!priceBrutto) this.item.priceBrutto = ''
      else this.item.priceNetto = this.calculatePriceNetto(priceBrutto)
    },
    customPriceBruttoSelected (index) {
      let priceBrutto = this.item.customPrices[index].priceBrutto
      if (!priceBrutto) this.item.customPrices[index].priceNetto = ''
      else this.setCustomPriceNetto(priceBrutto, index)
    },
    customPriceNettoSelected (index) {
      let priceNetto = this.item.customPrices[index].priceNetto
      if (!priceNetto) this.item.customPrices[index].priceBrutto = ''
      else this.setCustomPriceBrutto(priceNetto, index)
    },
    setCustomPriceNetto (priceBrutto, index) {
      this.item.customPrices[index].priceNetto = this.calculatePriceNetto(priceBrutto)
    },
    setCustomPriceBrutto (priceNetto, index) {
      this.item.customPrices[index].priceBrutto = this.calculatePriceBrutto(priceNetto)
    },
    removePriceUserData (index) {
      this.item.customPrices.splice(index, 1)
    },
    addPriceUserData () {
      this.item.customPrices.push({
        idUserData: '',
        priceBrutto: '',
        idPromotion: ''
      })
    },
    submit (item) {
      if (this.item.minimumAvailability) this.item.minimumAvailability = parseInt(this.item.minimumAvailability)
      if (this.item.warningAvailability) this.item.warningAvailability = parseInt(this.item.warningAvailability)
      if (this.item.priceBrutto) {
        this.item.priceBrutto = this.item.priceBrutto.toString()
      } else {
        this.item.priceBrutto = '0'
      }
      if (this.item.priceNetto) {
        this.item.priceNetto = this.item.priceNetto.toString()
      } else {
        this.item.priceNetto = '0'
      }
      if (this.item.purchasePriceNetto) {
        this.item.purchasePriceNetto = this.item.purchasePriceNetto.toString()
      } else {
        this.item.purchasePriceNetto = '0'
      }
      if (this.item.weight) {
        this.item.weight = this.item.weight.toString()
      } else {
        this.item.weight = '0'
      }
      if (this.item.width) {
        this.item.width = this.item.width.toString()
      } else {
        this.item.width = '0'
      }
      this.handleSubmit(item)
    },
    calculatePriceNetto (priceBrutto) {
      let vatRate = (this.vatRate / 100)
      return Math.round((priceBrutto / (1 + vatRate)) * 100) / 100
    },
    calculatePriceBrutto (priceNetto) {
      return Math.round((priceNetto * (1 + (this.vatRate / 100))) * 100) / 100
    },
    getIdLink (link) {
      return getId(link)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchItemTagOptions () {
      let baseParams = { pagination: false, tagType: 5 }
      const response = await new ApiService('e_x_c_m_tags', baseParams).getResults()
      this.itemTagOptions = response.items.map(tag => {
        return {
          value: tag['@id'],
          text: tag.tag
        }
      })
    },
    onSelectTags (items, lastSelectItem) {
      this.item.itemTags = items
      this.lastSelectTag = lastSelectItem
    }
  }
}
</script>
